import { Component } from '@angular/core';
import { SidebarMenu } from './sidebarMenu/sidebarMenu.component';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'sidebar',
  standalone: true,
  template: `<div class="layout-sidebar">
    <!-- The logo doubles as the way home: / resolves to the org's first supervisor, which is the
         app's landing page. -->
    <a routerLink="/" class="flex w-full items-center overflow-hidden px-4 py-6" aria-label="Go to home">
      <img src="/assets/main-logo.png" alt="Supervisr.ai logo" class="w-36" />
    </a>

    <div class="layout-menu-container">
      <sidebarMenu></sidebarMenu>
    </div>
  </div>`,
  imports: [SidebarMenu, RouterModule],
})
export class Sidebar {}
